import { makeStyles } from '@material-ui/core'
import RightArrowIcon from 'components/CopilotControl/icons/RightArrowIcon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useCanViewCopilotPatients } from '../../hooks/useCopilotAccountOwnerId'

const useStyles = makeStyles(theme => ({
  hoverFooter: {
    height: 50,
    position: 'absolute',
    padding: '0 13px',
    background: 'white',
    borderRadius: 24,
    width: '100%',
    boxShadow: '0px -10px 10px 5px white',
    right: 0,
    bottom: 0,
    display: 'flex',
    zIndex: 2,
    transition: 'opacity 0.5s',
    opacity: 1,
    pointerEvents: 'auto'
  },
  hoverFooterHidden: {
    opacity: 0,
    height: 50,
    pointerEvents: 'none'
  },
  seePatientsButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    font: 'inherit'
  },
  seePatientsText: {
    color: '#3C52EF',
    fontFamily: 'Dazzed',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '24px',
    [theme.breakpoints.up('lg')]: {
      fontSize: 14
    }
  }
}))

const SeePatientsFooter = ({ visible, onClick }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  // A Sales-only doctor override shows totals without patient lists, so there is nothing to open.
  const canViewPatients = useCanViewCopilotPatients()

  if (!canViewPatients) {
    return null
  }

  return (
    <div className={visible ? classes.hoverFooter : `${classes.hoverFooter} ${classes.hoverFooterHidden}`}>
      <button type="button" className={classes.seePatientsButton} onClick={onClick} tabIndex={visible ? 0 : -1}>
        <span className={classes.seePatientsText}>{t('pages.oralHygieneReport.widgets.seePatients')}</span>
        <RightArrowIcon />
      </button>
    </div>
  )
}

export default SeePatientsFooter
